import React from "react";
import styles from "./index.module.scss";
import AvatarC from "../../../avatar";
import Timer from "../../../timer";
import { FlipperVaultCardProps } from "../../index";

interface CheckedOutByOtherProps {
  flipperData: FlipperVaultCardProps;
  userDetail: any;
  type?: string;
  setIsExpired: (isExpired: boolean) => void;
}

export default function CheckedOutByOther({
  flipperData,
  userDetail,
  type,
  setIsExpired
}: CheckedOutByOtherProps) {
  return (
    <div className={styles.FlipperVaultCardCheckout}>
      <div className={styles.FlipperVaultCardOwner}>
        {/* <AvatarC
          className={styles.avatar}
          size="normal"
          shape="circle"
          label={
            `${flipperData?.checkouts?.[
              flipperData?.checkouts?.length - 1
            ]?.userName
              .split(" ")[0]
              .charAt(0)}${flipperData?.checkouts?.[
              flipperData?.checkouts?.length - 1
            ]?.userName
              .split(" ")[1]
              .charAt(0)}` || "N/A"
          }
        /> */}
        <div>
          <div className={styles.FlipperVaultCardOwnerTitle}>
            CHECKED OUT BY
          </div>
          <div className={styles.FlipperVaultCardOwnerValue}>
            {flipperData?.checkouts?.[flipperData?.checkouts?.length - 1]
              ?.userName || "N/A"}
          </div>
        </div>
      </div>
      <Timer
        createdAt={
          flipperData?.checkouts?.[flipperData?.checkouts?.length - 1]
            ?.createdAt
        }
        ShowTitle={false}
        textColor={"Black"}
        acctId={flipperData?.acctId}
        time={
          flipperData?.checkouts[flipperData?.checkouts?.length - 1]?.expirtyAt
        }
        onExpire={() => setIsExpired(true)}
      />
    </div>
  );
}
